import { render, staticRenderFns } from "./detecation-template.vue?vue&type=template&id=84c158ba&scoped=true"
import script from "./detecation-template.vue?vue&type=script&lang=ts"
export * from "./detecation-template.vue?vue&type=script&lang=ts"
import style0 from "./detecation-template.vue?vue&type=style&index=0&id=84c158ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c158ba",
  null
  
)

export default component.exports